module.exports = __webpack_public_path__ + "static/img/photo11.8996e70e.jpg";